export enum NextAuthError {
  Configuration = `Configuration`,
  AccessDenied = `AccessDenied`,
  Verification = `Verification`,
  OAuthCallback = `OAuthCallback`,
  Callback = `Callback`,
  OAuthAccountNotLinked = `OAuthAccountNotLinked`,
  OAuthCreateAccount = `OAuthCreateAccount`,
  Default = `Default`,
}

type NextAuthErrorData = {
  isRecoverable: boolean;
  message: string;
  recoveryMessage?: string;
};

export const loginErrors: Record<NextAuthError, NextAuthErrorData> = {
  [NextAuthError.Configuration]: {
    isRecoverable: false,
    message: `Configuration error`,
  },
  [NextAuthError.AccessDenied]: {
    isRecoverable: true,
    message: `No Permission`,
    recoveryMessage: `Please contact your administrator`,
  },
  [NextAuthError.Verification]: {
    isRecoverable: true,
    message: `Token expired`,
    recoveryMessage: `Please try again`,
  },
  [NextAuthError.Default]: {
    isRecoverable: false,
    message: `Something we didn't expect happened`,
    recoveryMessage: `We are working on it`,
  },
  [NextAuthError.OAuthCallback]: {
    isRecoverable: false,
    message: `Something we didn't expect happened`,
    recoveryMessage: `We are working on it`,
  },
  [NextAuthError.Callback]: {
    isRecoverable: false,
    message: `Something we didn't expect happened`,
    recoveryMessage: `We are working on it`,
  },
  [NextAuthError.OAuthAccountNotLinked]: {
    isRecoverable: true,
    message: `Account not linked`,
    recoveryMessage: `Please try again with the account you used to sign up`,
  },
  [NextAuthError.OAuthCreateAccount]: {
    isRecoverable: false,
    message: `Something we didn't expect happened`,
    recoveryMessage: `We are working on it`,
  },
};

export class LoginError extends Error {
  data: (typeof loginErrors)[NextAuthError] | null = null;
  constructor(public code: NextAuthError) {
    super(code);
    this.data = loginErrors[code];
  }
}
